import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast5 extends BCComponent {

    render() {
        return (
            <div>
                <h1>VIDEO, PREZENTACE</h1>
                <div className='separate-bottom'>
                    <p>Videa jsou zábavným moderním výukovým nástrojem. Na internetu najdeme nepřeberné množství videí, díky nimž se můžeme vzdělávat a rozvíjet. I zde je ale zapotřebí dobře vybírat - některá videa totiž slouží jenom pro zábavu. Výhodou videa je spojení různých vjemů - vnímají při něm uši i oči. A to, ať už se jedná o hrané video, animaci nebo o komentované statické obrázky. Pokud video sami vytvoříte, osvojíte si další dovednosti a proniknete do tématu z jiného pohledu.</p>
                    <p>Jiným výukovým nástrojem, při kterém se hodně přiučíte, jsou prezentace. Když připravujeme prezentaci (referát apod.), musíme se nejdříve dobře seznámit s daným tématem (např. pomocí internetu, knížek nebo videí) a potom přemýšlet o tom, jakým způsob téma podáme svým “žákům”, aby jej pochopili.</p>
                </div>

                { this.showTask("zs_video_1") }
                { this.showTask("zs_video_2") }
                { this.showTask("zs_video_3") }
                { this.showTask("zs_video_4") }
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast5);
